import { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { SelectChangeEvent } from "@mui/material/Select"
import { useMmsService } from "services/mms/context/MmsServiceContext.tsx"
import { EntityInfo } from "types/entity"
import SelectedEntity from "layouts/payment/selected-entity.tsx"
import PaymentMethod from "layouts/payment/payment-method.tsx"
import { ContainerDisplayPayment } from "layouts/payment/payment-info.tsx"
import { ChoosePaymentMethod } from "layouts/payment/popup/ChoosePaymentMethod.tsx"
import { MethodOfPaymentProcess } from "types/paymentMethod.ts"
import { AllPaymentProvider } from "layouts/payment/payment-context.tsx"
import { AddPaymentMethod } from "layouts/payment/popup/AddPaymentMethod.tsx"

export const PaymentPage = () => {
    const [selfEntity, setSelfProfile] = useState<EntityInfo | null>(null)
    const mmsService = useMmsService()

    const profileService = mmsService.getProfileService()
    const { data, sendRequest: fetchEntity } = profileService.useGetSelfEntity()
    const [entitySelected, setEntitySelected] = useState<string>("")

    const [isAddPaymentPopupOpen, setAddPaymentPopupOpen] = useState(false)
    const [currentProcess, setCurrentProcess] =
        useState<MethodOfPaymentProcess | null>(null)

    useEffect(() => {
        fetchEntity()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (data) {
            const typedData = data as EntityInfo
            setSelfProfile(typedData)
            setEntitySelected(typedData.entity_name)
        }
    }, [data])

    const handleChange = (event: SelectChangeEvent) => {
        setEntitySelected(event.target.value)
    }

    const handleAddPaymentClick = () => {
        setCurrentProcess(MethodOfPaymentProcess.CHOOSE_METHOD)
        setAddPaymentPopupOpen(true)
    }

    const handleAddPaymentPopupClose = () => {
        setAddPaymentPopupOpen(false)
        setCurrentProcess(null)
    }

    return (
        <AllPaymentProvider>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "2rem",
                    p: 1,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                        width: "100%",
                    }}
                >
                    <SelectedEntity
                        value={entitySelected}
                        onChange={handleChange}
                        options={[
                            {
                                value: selfEntity?.entity_name || "",
                                label: selfEntity?.entity_name || "",
                            },
                        ]}
                    />
                    <ContainerDisplayPayment />
                </Box>
                <PaymentMethod onAddPaymentClick={handleAddPaymentClick} />
                {currentProcess == MethodOfPaymentProcess.CHOOSE_METHOD && (
                    <ChoosePaymentMethod
                        onClose={handleAddPaymentPopupClose}
                        isOpen={isAddPaymentPopupOpen}
                        setCurrentProcess={setCurrentProcess}
                    />
                )}
                {currentProcess == MethodOfPaymentProcess.ADD_CREDIT_CARD && (
                    <AddPaymentMethod
                        isOpen={isAddPaymentPopupOpen}
                        onClose={handleAddPaymentPopupClose}
                        paymentType="creditCard"
                    />
                )}
                {currentProcess ==
                    MethodOfPaymentProcess.ADD_CURRENT_ACCOUNT && (
                    <AddPaymentMethod
                        isOpen={isAddPaymentPopupOpen}
                        onClose={handleAddPaymentPopupClose}
                        paymentType="currentAccount"
                    />
                )}
            </Box>
        </AllPaymentProvider>
    )
}
